import { METRIC_PRESETS } from "../../../constants/reportBuilder.js";
import { metricIsComplete } from "../../../logic/services/reportBuilderMetrics.js";
import { primaryButton } from "../../../components/ui/buttonStyles.js";
import { Ico } from "../../../components/icons/icons.jsx";
import { MetricCard } from "../components/MetricCard.jsx";
import { rbSectionHint } from "../reportBuilderTheme.js";

export function MetricsStep({
  metrics,
  fields,
  onAdd,
  onAddPreset,
  onUpdate,
  onRemove,
  onClone,
  onMove,
  stepError,
  c,
  A,
  dark,
}) {
  const completeCount = metrics.filter(metricIsComplete).length;
  const availablePresets = METRIC_PRESETS.filter((p) => {
    if (p.sourceType === "expression") return true;
    if (!p.field) return true;
    return fields.includes(p.field);
  });

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
      <p style={{ ...rbSectionHint(c), margin: 0 }}>
        Build metrics from fields or custom expressions. Set aliases, display formats, conditional FILTER clauses, and sort order per metric.
      </p>

      {availablePresets.length > 0 ? (
        <div>
          <span style={{ display: "block", fontSize: 10, fontWeight: 700, letterSpacing: "0.06em", textTransform: "uppercase", color: c.sub, marginBottom: 8 }}>
            Quick presets
          </span>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 8 }}>
            {availablePresets.map((preset) => (
              <button
                key={preset.id}
                type="button"
                onClick={() => onAddPreset(preset.id)}
                style={{
                  padding: "6px 12px",
                  borderRadius: 8,
                  border: `1px solid ${c.cardBdr}`,
                  background: c.card,
                  color: c.mid,
                  fontSize: 12,
                  fontWeight: 600,
                  cursor: "pointer",
                }}
                onMouseEnter={(e) => (e.currentTarget.style.borderColor = `${A}55`)}
                onMouseLeave={(e) => (e.currentTarget.style.borderColor = c.cardBdr)}
              >
                + {preset.label}
              </button>
            ))}
          </div>
        </div>
      ) : null}

      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {metrics.map((m, i) => (
          <MetricCard
            key={m.id}
            metric={m}
            index={i}
            total={metrics.length}
            fields={fields}
            onChange={(patch) => onUpdate(m.id, patch)}
            onRemove={() => onRemove(m.id)}
            onClone={() => onClone(m.id)}
            onMoveUp={() => onMove(m.id, -1)}
            onMoveDown={() => onMove(m.id, 1)}
            canRemove={metrics.length > 1}
            c={c}
            A={A}
          />
        ))}
      </div>

      <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, flexWrap: "wrap" }}>
        <button type="button" onClick={onAdd} style={primaryButton(A, { dark, height: 34, fontSize: 12 })}>
          {Ico.plus}
          Add custom metric
        </button>
        <span style={{ fontSize: 11, color: stepError ? "#EF4444" : c.sub, fontWeight: stepError ? 600 : 400 }}>
          {stepError ?? `${completeCount} of ${metrics.length} metric${metrics.length === 1 ? "" : "s"} ready`}
        </span>
      </div>
    </div>
  );
}
